import React from 'react';
import classes from './StatusMessage.module.scss';
import cx from 'classnames';

const StatusMessage = ({
    title,
    text,
    rejected,
    className
}: any) => {
    return (
        <div className={cx(classes.message, className, { [classes.success]: !rejected, [classes.reject]: rejected } )}>
            <div className={classes.title}>
                <div className={classes.logo}></div>
                <div className={classes.titleContent}>{title}</div>
            </div>
            <div className={classes.text}>
                {text}
            </div>
        </div>
    )
}

export default StatusMessage
